import React from 'react';

/**
 * Component to display the Status Solutons "S" logo as an svg
 * @param {*} props - Generic parameter to pass along any desired props to the component
 */
const SvgStatusSLogo = (props) => (
  <svg id="StatusSLogo" data-name="Layer 1" viewBox="0 0 80 80" {...props}>
    <title>Status Solutions Logo</title>
    <defs>
      <style>
        {
          '.StatusSLogo_svg__cls-1,.StatusSLogo_svg__cls-2{fill:#ee3e33;fill-rule:evenodd}.StatusSLogo_svg__cls-2{fill:#ef3e33}'
        }
      </style>
    </defs>
    <path
      className="StatusSLogo_svg__cls-1"
      d="M78.32 36.5l-22.55-5 .07-.88L80 26.67a25.28 25.28 0 0 1-1.68 9.83zM73.64 13.62L56.21 27.37 56 28.45l23.21-6.62a16.67 16.67 0 0 0-5.57-8.21zM60.19 8.63l-3.81 15.9 13.29-13.4a26.16 26.16 0 0 0-9.48-2.5z"
    />
    <path
      className="StatusSLogo_svg__cls-2"
      d="M54.24 8.46L54.3 24a39.89 39.89 0 0 0-8.84-.91c-5.8 0-15.32 1.75-16.6 9.58s10.84 12.11 8 15.39c-3.28 3.82-32.71-9-32.71-9S11 26 27.26 16.83c15.85-8.89 26.98-8.37 26.98-8.37z"
    />
    <path
      className="StatusSLogo_svg__cls-1"
      d="M1.68 44.49l22.55 5-.07.88L0 54.32a25.31 25.31 0 0 1 1.68-9.83zM6.36 67.37l17.43-13.74.21-1.09L.79 59.16a16.67 16.67 0 0 0 5.57 8.21zM19.81 72.37l3.81-15.91-13.29 13.4a26 26 0 0 0 9.48 2.51z"
    />
    <path
      className="StatusSLogo_svg__cls-2"
      d="M25.76 72.53L25.7 57a40.65 40.65 0 0 0 8.84.91c5.8 0 15.32-1.76 16.6-9.59s-10.84-12.11-8-15.39c3.28-3.82 32.71 9 32.71 9S69 55 52.74 64.16c-15.85 8.89-26.98 8.37-26.98 8.37z"
    />
  </svg>
);

export default SvgStatusSLogo;
